import genericConstants from "../../../../platform_common_constants/constants.json";
export {genericConstants}

export const getSplitComponentKey = (key) => {
  return key.split(genericConstants.SPECIFIC_COMPONENT_SPLITTER);
};

export const getPossibleComponentKey = (key) => {
  return getSplitComponentKey(key)[0];
}

export const getMappingForKey = (key, mappingObject) => {
  return mappingObject[getPossibleComponentKey(key)];
};

export const getSubmitHandlerForKey = (key, filterKeyToSubmitHandlerMap) => {
  return getMappingForKey(key, filterKeyToSubmitHandlerMap);
};

export const getCompatibilityHandlerForKey = (key, filterKeyToCompatibilityHandlerMap) => {
  return getMappingForKey(key,filterKeyToCompatibilityHandlerMap);
};

export const commonTrackingPayloadForKey = (key, filterKeyToTrackingPayloadMap) => {
  return getMappingForKey(key, filterKeyToTrackingPayloadMap);
}

export const getDataForKey = (key, store) => {
  const [genericKey, specificKey] = getSplitComponentKey(key);
  return {
    genericKey,
    specificKey,
    formData: store.form[key].snapshots.current,
    seedData: store.seed?.[genericKey]
  };
};

export const getFilterTypeForKey = (key, store) => {
  return store.form[key].filterType;
};

// TODO_CONNECTION_VIEWS_LOW : name is misleading
export const getTitleForKey = (translations) => {
  return translations.filterTitle;
};

export const getComponentForKey = (key, filterKeyToComponentMap) => {
  return getMappingForKey(key, filterKeyToComponentMap);
};

export const getFilterLabelForEventTracker = (key) => {
  const [genericKey, specificKey] = getSplitComponentKey(key);
  return {
    genericKey,
    specificKey
  }
}